var $e73bf42412feb220$exports = {};
const $e73bf42412feb220$var$observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -60px 0px'
};
const $e73bf42412feb220$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            $e73bf42412feb220$var$observer.unobserve(entry.target);
        }
    });
}, $e73bf42412feb220$var$observerOptions);
document.querySelectorAll('.animate-fade-in-up, .animate-slide-in-left, .animate-slide-in-right').forEach((el)=>{
    $e73bf42412feb220$var$observer.observe(el);
});


//# sourceMappingURL=mestre-dos-parafusos.de268cb2.js.map
